export function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background overflow-hidden">
      <div className="relative w-24 h-24 flex items-center justify-center">
        {/* Background circle */}
        <div className="absolute inset-0 border-2 border-gold/20 rounded-full" />
        {/* Spinning circle */}
        <div className="absolute inset-0 border-2 border-gold border-t-transparent rounded-full animate-spin" />
        {/* Text */}
        <span className="text-[10px] font-medium tracking-[0.2em] text-gold">
          LEESTONE
        </span>
      </div>
    </div>
  );
}
